import request from '@/request'

/**
 * 获取公众号列表
 * @param params
 * @returns {AxiosPromise}
 */
export function get_blog_list(params) {
  const url = '/api/v1/blog/list'
  return request({ url, method: 'GET', params: params })
}

/**
 * 获取公众号关键词列表
 * @param data
 * @returns {AxiosPromise}
 */
export function get_blog_word_list(data) {
  const url = '/api/v1/blog/word_list'
  return request({ url, method: 'POST', data: data })
}

/**
 * 搜索公众号列表
 * @param data
 * @returns {AxiosPromise}
 */
export function search_blog(data) {
  const url = '/api/v1/blog/search'
  return request({ url, method: 'POST', data: data })
}

/**
 * 修改/添加 关键词
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_blog_word(data) {
  const url = '/api/v1/blog/modify_word'
  return request({ url, method: 'POST', data })
}

/**
 * 修改公众号相关配置
 * @param data
 * @returns {AxiosPromise}
 */
export function modify(data) {
  const url = '/api/v1/blog/modify'
  return request({ url, method: 'POST', data })
}

/**
 * 获取公众号详情
 * @param data
 * @returns {AxiosPromise}
 */
export function blog_detail(data) {
  const url = '/api/v1/blog/detail'
  return request({ url, method: 'POST', data })
}

/**
 * 获取授权链接
 * @param data
 * @returns {AxiosPromise}
 */
export function get_auth_link() {
  const url = '/api/v1/blog/get_auth_link'
  return request({ url, method: 'POST' })
}

/**
 * 修改授权公众号
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_auth_blog(data) {
  const url = '/api/v1/blog/modify_auth_blog'
  return request({ url, method: 'POST', data })
}

/**
 * 公众号获取用户数据
 * @param data
 * @returns {AxiosPromise}
 */
export function user_chart(data) {
  const url = '/api/v1/blog/user_chart'
  return request({ url, method: 'POST', data })
}

/**
 * 公众号获取消息数据
 * @param data
 * @returns {AxiosPromise}
 */
export function message_chart(data) {
  const url = '/api/v1/blog/message_chart'
  return request({ url, method: 'POST', data })
}

/**
 * 公众号获取内容分析数据
 * @param data
 * @returns {AxiosPromise}
 */
export function content_chart(data) {
  const url = '/api/v1/blog/content_chart'
  return request({ url, method: 'POST', data })
}

/**
 * 公众号获取内容分析数据
 * @param data
 * @returns {AxiosPromise}
 */
export function sync_data(data) {
  const url = '/api/v1/blog/sync_data'
  return request({ url, method: 'POST', data })
}

/**
 * 获取公众号推广员的数组
 * @param data
 * @returns {AxiosPromise}
 */
export function agent_list(data) {
  const url = '/api/v1/blog/agent_list'
  return request({ url, method: 'POST', data })
}

/**
 * 获取公众号推广员的数组
 * @param data
 * @returns {AxiosPromise}
 */
export function band_agent(data) {
  const url = '/api/v1/blog/band_agent'
  return request({ url, method: 'POST', data })
}

/**
 * 获取公众号推广员的数组
 * @param data
 * @returns {AxiosPromise}
 */
export function remove_agent(data) {
  const url = '/api/v1/blog/remove_agent'
  return request({ url, method: 'POST', data })
}
